import { render, staticRenderFns } from "./AppNavigationListMain.vue?vue&type=template&id=0590b9e8&"
import script from "./AppNavigationListMain.vue?vue&type=script&lang=js&"
export * from "./AppNavigationListMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports